const PARENT_PATHS = {
	DASHBOARD: '/dashboards',
	ACCOUNT: '/account',
	CONFIGURATION: '/configuration',
	CALLS: '/calls',
	EXCLUSION_LIST: '/exclusion-list',
	SPECIAL_LOCATIONS: '/special-locations',
	PHONE_NUMBERS: '/phone-numbers',
	AUTHENTICATION: {
		BASE: '/authentication',
		SIGN_IN: '/authentication/sign-in',
		SIGN_UP: '/authentication/sign-up',
		RESET_PASSWORD: '/authentication/reset-password',
	},
}

export const ROUTE_PATHS = {
	DASHBOARD: {
		ANALYTICS: `${PARENT_PATHS.DASHBOARD}/analytics`,
	},
	CALLS: {
		BASE: `${PARENT_PATHS.CALLS}`,
		DETAIL: `${PARENT_PATHS.CALLS}/:callId`,
	},
	EXCLUSION_LIST: {
		BASE: `${PARENT_PATHS.EXCLUSION_LIST}`,
		MANAGE: `${PARENT_PATHS.EXCLUSION_LIST}/manage`,
		DETAIL: `${PARENT_PATHS.EXCLUSION_LIST}/manage/:id`,
		NEW: `${PARENT_PATHS.EXCLUSION_LIST}/new`,
	},
	SPECIAL_LOCATIONS: {
		BASE: `${PARENT_PATHS.SPECIAL_LOCATIONS}`,
		MANAGE: `${PARENT_PATHS.SPECIAL_LOCATIONS}/manage`,
		DETAIL: `${PARENT_PATHS.SPECIAL_LOCATIONS}/manage/:id`,
		NEW: `${PARENT_PATHS.SPECIAL_LOCATIONS}/new`,
		AMBIGUOUS: `${PARENT_PATHS.SPECIAL_LOCATIONS}/ambiguous`,
		PAYPHONE: `${PARENT_PATHS.SPECIAL_LOCATIONS}/payphone`,
	},
	PHONE_NUMBERS: {
		BASE: `${PARENT_PATHS.PHONE_NUMBERS}`,
	},
	ACCOUNT: {
		SETTINGS: `${PARENT_PATHS.ACCOUNT}/settings`,
	},
	AUTHENTICATION: {
		SIGN_IN: `${PARENT_PATHS.AUTHENTICATION.SIGN_IN}`,
		RESET_PASSWORD: `${PARENT_PATHS.AUTHENTICATION.RESET_PASSWORD}`,
	},
	CONFIGURATION: {
		BASE: `${PARENT_PATHS.CONFIGURATION}`,
		API_INTEGRRATION: `${PARENT_PATHS.CONFIGURATION}/api-integrations`,
	},
}
